<!-- First step of the publish flow: choose the dynamic-form namespace. -->
<main class="category-gate" aria-labelledby="category-gate-title">
  <header class="gate-intro">
    <div class="step-badge" aria-label="שלב 1 מתוך תהליך פרסום המודעה">
      <span class="step-number">1</span>
      <span>בחירת קטגוריה</span>
    </div>
    <h1 id="category-gate-title">מה תרצו לפרסם?</h1>
    <p>בחרו קטגוריה ונציג לכם טופס קצר שמותאם בדיוק לסוג המודעה.</p>
  </header>

  @if (isLoading) {
    <section class="gate-status" aria-live="polite">
      <span class="loading-spinner" aria-hidden="true"></span>
      <strong>טוענים את הקטגוריות...</strong>
    </section>
  } @else if (loadError) {
    <section class="gate-status gate-error" role="alert">
      <span class="status-icon" aria-hidden="true">!</span>
      <div>
        <strong>לא הצלחנו לטעון את הקטגוריות</strong>
        <p>בדקו את החיבור ונסו שוב.</p>
      </div>
      <button type="button" class="retry-button" (click)="loadData()">נסו שוב</button>
    </section>
  } @else {
    @if (firstCategory.length) {
      <section class="category-group" aria-labelledby="popular-categories-title">
        <div class="group-heading">
          <div>
            <h2 id="popular-categories-title">קטגוריות מרכזיות</h2>
            <p>התחילו בבחירת סוג המודעה</p>
          </div>
          <span class="group-count">{{ firstCategory.length }}</span>
        </div>
        <div class="category-grid primary-grid">
          @for (category of firstCategory; track category.category) {
            <button
              type="button"
              class="category-card primary-card"
              [class.is-selected]="selectedCategory === category"
              [disabled]="isNavigating"
              [attr.aria-pressed]="selectedCategory === category"
              (click)="SelectMainCategory(category)">
              <span class="card-check" aria-hidden="true">✓</span>
              <span class="category-icon" aria-hidden="true">
                <mat-icon>{{ iconFor(category) }}</mat-icon>
              </span>
              <span class="category-name">{{category.name}}</span>
              <span class="category-hint">לבחירת הקטגוריה</span>
            </button>
          }
        </div>
      </section>
    }

    @if (secondCategory.length || thirdCategory.length) {
      <section class="category-group" aria-labelledby="more-categories-title">
        <div class="group-heading compact-heading">
          <div>
            <h2 id="more-categories-title">קטגוריות נוספות</h2>
            <p>כל שאר סוגי המודעות במקום אחד</p>
          </div>
        </div>

        @if (secondCategory.length) {
          <div class="category-grid secondary-grid">
            @for (category of secondCategory; track category.category) {
              <button
                type="button"
                class="category-card secondary-card"
                [class.is-selected]="selectedCategory === category"
                [disabled]="isNavigating"
                [attr.aria-pressed]="selectedCategory === category"
                (click)="SelectMainCategory(category)">
                <span class="card-check" aria-hidden="true">✓</span>
                <span class="category-icon small-icon" aria-hidden="true">
                  <mat-icon>{{ iconFor(category) }}</mat-icon>
                </span>
                <span class="category-name">{{category.name}}</span>
              </button>
            }
          </div>
        }

        @if (thirdCategory.length) {
          <div class="category-grid tertiary-grid">
            @for (category of thirdCategory; track category.category) {
              <button
                type="button"
                class="category-card tertiary-card"
                [class.is-selected]="selectedCategory === category"
                [disabled]="isNavigating"
                [attr.aria-pressed]="selectedCategory === category"
                (click)="SelectMainCategory(category)">
                <span class="card-check" aria-hidden="true">✓</span>
                <span class="category-icon small-icon" aria-hidden="true">
                  <mat-icon>{{ iconFor(category) }}</mat-icon>
                </span>
                <span class="category-name">{{category.name}}</span>
              </button>
            }
          </div>
        }
      </section>
    }
  }

  @if (isNavigating) {
    <div class="navigation-status" role="status" aria-live="polite">
      <span class="loading-spinner" aria-hidden="true"></span>
      <span>מכינים את הטופס המתאים...</span>
    </div>
  }
</main>
